import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);
import '@/assets/css/lib.scss';
import '@/assets/css/style.css';
import '@/utils/rem.js';
import '@/utils/filter.js';
import '@/assets/js/lib.js'
import './permission' // permission control
Vue.config.productionTip = false

import utils from '@/utils/utils'
Vue.prototype.$utils = utils;
Vue.use(ElementUI);
import ElementUI from '@femessage/element-ui';
import '@femessage/element-ui/lib/theme-chalk/index.css';
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 全局mixins
import configMixin from '@/utils/configMixin'
Vue.mixin(configMixin)

// 初始化配置
store.dispatch('config/initConfig')
